module.exports = {"410303001":"王城路街道","410303002":"金谷园街道","410303003":"西工街道","410303004":"邙岭路街道","410303006":"唐宫路街道","410303007":"汉屯路街道","410303008":"凯旋东路街道","410303009":"洛北街道","410303010":"红山街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410303.json
// module id = 1539
// module chunks = 0